import { useLink } from "../../other/navigationAndRouting/useLink";
import { communityArticleRoute } from "../../other/navigationAndRouting/routes";

export function useInternalMediaLink(id: string) {
    return useLink({
        route: communityArticleRoute,
        pathParams: { id }
    });
}
